// extracted by mini-css-extract-plugin
export default {"groupColumns":"W7zk6w5"};